require('./importClassCodesModal.i18n.json');
require('./importClassCodesModal.tpl.html');
require('./importClassCodesRepository.js');

/*@ngInject*/
const ImportClassCodesModalController = function ($rootScope, $scope, coreConstant, $timeout, localization, attachmentUtil, modalUtil, configurationMediator, loadingBarHandler, xmlUtil) {

    localization.getTranslationByKey('importClassCodes').then(function (translations) {
        $scope.viewModel = {
            title: translations.title,
            cancelButton: translations.cancelButton,
            confirmButton: translations.confirmButton,
            or: translations.or,
            dragAndDrop: translations.dragAndDrop,
            uploadedFile: null,
            importFileString: translations.chooseFile,
            attachment: {},
            acceptedTypes: ['.txt']
        };

        $scope.onCancel = function () {
            $scope.$dismiss();
        };

        $scope.fileSelected = function (file) {
            if (file) {
                storeUploadedFile(file);
            }
        };

        $scope.onConfirm = function () {
            $scope.$close();
            loadingBarHandler.showLoadingBar(translations.loadingBar + ' ' + $scope.viewModel.attachment.name);
            configurationMediator.importClassCodes($scope.viewModel.uploadedFile).then(function (result) {
                loadingBarHandler.hideLoadingBar();
                if (parseInt(xmlUtil.parseString(result).status) === -1) {
                    let config = {
                        confirmActionButtonLabel: translations.okButtonLabel,
                        summary: xmlUtil.parseString(result).message,
                        title: translations.errorTitle
                    };
                    modalUtil.showGenericConfirm(config);
                } else {
                    $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, translations.successMessage + ' ' + $scope.viewModel.attachment.name);
                }

            }, function () {
                // On Error
                loadingBarHandler.hideLoadingBar();
            });
        };

        $scope.canEnableConfirmButton = function () {
            return $scope.viewModel.attachment.name && $scope.viewModel.attachment.size;
        };

        function storeUploadedFile(uploadedFile) {
            var allowFile = attachmentUtil.validateAttachmentType(uploadedFile, _.get(translations, 'unacceptableType'), $scope.viewModel.acceptedTypes);
            if (allowFile) {
                $timeout(function () {
                    $scope.viewModel.uploadedFile = uploadedFile;
                    if (!$scope.viewModel.attachment) {
                        $scope.viewModel.attachment = {};
                    }
                    $scope.viewModel.attachment.name = uploadedFile.name;
                    $scope.viewModel.attachment.size = uploadedFile.size;
                }, 0);
            }
        }

        $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
            $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
        });

        $scope.$on(coreConstant.event.FILE_DROPPED, function (event, file) {
            if (file) {
                storeUploadedFile(file);
            }
        });

        $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
    });
};

angular.module('ums.configuration')
    .controller('importClassCodesModalController', ImportClassCodesModalController);
